<a
  [ngClass]="{
    'training-card': true,
    'training-card-locked': isLocked,
    'learning-path-locked': isLocked && isLearningPath
  }"
  [routerLink]="shouldDisableLink() ? null : getCardLink().commands"
  [queryParams]="shouldDisableLink() ? null : getCardLink().queryParams"
>
  <span class="new-badge" *ngIf="isNew && !isLocked">
    {{ "COMMON.NEW" | translate }}
  </span>
  <i class="fa-solid fa-lock lock-icon" *ngIf="isLocked"></i>
  <div
    class="training-card-disabled-overlay"
    *ngIf="training.status == 3 && isLearningPath"
  ></div>
  <div
    class="training-card-completed-icon"
    *ngIf="training.status == 2 && isLearningPath"
  >
    <i class="dx-icon-check"></i>  
  </div>
  <img
    class="training-image"
    [src]="imageUrl | safe:'url'"
    appTrainingImageFallback
  />
  <div class="training-details">
    <div>
      <h2 class="training-name">{{ training.name }}</h2>
      <div class="training-description">{{ training.description }}</div>
    </div>
    <div class="trainer">
      <app-trainer-group 
        [trainers]="trainers"
      ></app-trainer-group>
    </div>
    <div>
      <div class="training-badge" *ngIf="training.type == 'Training'">
        <div
          class="training-badge-container"
          *ngIf="training.dates && training.dates[0]"
        >
          <div class="training-badge-content">
            <i class="dx-icon dx-svg-icon" [innerHTML]="getCalendarIcon()"></i>
            {{
              training.dates[0].start
                | date : "dd LLL yyyy" : "" : translateService.currentLang
            }}
          </div>
        </div>
      </div>
      <div class="training-badge">
        <div class="training-badge-container">
          <div
            class="training-badge-content"
            *ngIf="training.type == 'Course' || isLearningPath"
          >
            <i
              class="dx-icon dx-svg-icon play-icon"
              [innerHTML]="getPlayIcon()"
            ></i>
            Elearning
          </div>
          <div
            class="training-badge-content"
            *ngIf="training.type == 'Training'"
          >
            <i
              class="dx-icon dx-svg-icon play-icon"
              [innerHTML]="getPlayIcon()"
            ></i>
            <span *ngIf="training.location.type === 0">{{
              "COMMON.FIELDS.EVENT-TYPES.IN-PERSON" | translate
            }}</span>
            <span *ngIf="training.location.type === 1">{{
              "COMMON.FIELDS.EVENT-TYPES.WEB" | translate
            }}</span>
            <span *ngIf="training.location.type === 2">{{
              "COMMON.FIELDS.EVENT-TYPES.WEBEX-WEBINAR" | translate
            }}</span>
            <span *ngIf="training.location.type === 3">{{
              "COMMON.FIELDS.EVENT-TYPES.ONLINE" | translate
            }}</span>
            <span *ngIf="training.location.type === 6">{{
              "COMMON.FIELDS.EVENT-TYPES.GO-TO-WEBINAR" | translate
            }}</span>
          </div>
        </div>
        <div class="training-badge-container" *ngIf="!isLearningPath">
          <div class="training-badge-content">
            <i
              class="dx-icon dx-svg-icon play-icon"
              [innerHTML]="getCategoryIcon()"
            ></i>
            <span *ngIf="training.trainingType === 0">{{
              "COMMON.FIELDS.TRAINING-TYPES.IDD" | translate
            }}</span>
            <span *ngIf="training.trainingType === 1">{{
              "COMMON.FIELDS.TRAINING-TYPES.COMPLIANCE" | translate
            }}</span>
            <span *ngIf="training.trainingType === 2">{{
              "COMMON.FIELDS.TRAINING-TYPES.GENERAL" | translate
            }}</span>
          </div>
        </div>
        <i
          *ngIf="training.isBookmarked && !isLearningPath"
          class="dx-icon dx-bookmark-icon svg-red"
          [innerHTML]="getBookmarkIcon()"
        ></i>
      </div>
    </div>
  </div>
</a>
